module.exports = __webpack_public_path__ + "src/img/stopWatch/15162d82f73e3b0680641fc162024eb7.png";